export default __webpack_public_path__ + "static/media/mkk2_dark.d892bf62.png";